// Copyright (c) Docugami, Inc. All rights reserved.

import { dgFontFamily } from "components/common/Fonts";
import { greyText } from "components/shell/presentation/AppStyles";
import { useTimeout } from "hooks/Timeout";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { ActiveDropTargetStyle, ItemSlot, UnconfirmedClassName } from "./ItemSlot";
import { SlidingPanel } from "./SlidingPanel";

export const Text = styled.span`
    font-family: ${dgFontFamily};
    font-size: 12px;
    font-weight: 500;
    color: ${greyText};
`;

const Content = styled.div<{ isClickable?: boolean }>`
    display: flex;
    width: 100%;
    flex: 1;
    justify-content: center;
    align-items: center;
    height: 100%;
    cursor: ${props => props.isClickable ? 'pointer' : 'default'};
`

interface PlaceholderSlotVisualProps {
    text?: string;
    isVisible?: boolean;
    isActive?: boolean;
    onClick?: () => void;
}

export const PlaceholderSlotVisual = (props: PlaceholderSlotVisualProps): JSX.Element => {
    const [isOpen, setIsOpen] = useState(!!props.isVisible);

    useTimeout(() => setIsOpen(!!props.isVisible), !!props.isVisible ? 150 : 0, props.isVisible);

    useEffect(() => {
        if (!props.isVisible) {
            setIsOpen(false);
        }
    }, [props.isVisible]);

    if (!isOpen) {
        return <></>;
    }

    const styles: string[] = [UnconfirmedClassName];
    if (!!props.isActive) {
        styles.push(ActiveDropTargetStyle)
    }

    return (
        <SlidingPanel isOpen={isOpen} durationS={.25}>
            <ItemSlot hideManagementCommands={true} styles={{ root: styles }} onClick={props.onClick}>
                <Content isClickable={!!props.onClick}>
                    <Text>{props.text}</Text>
                </Content>
            </ItemSlot>
        </SlidingPanel>
    );
}
